import React, { useState, useEffect, useContext } from 'react';
import {
    Modal,
    Box,
    Typography,
    TextField,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Switch,
    Button,
    IconButton,
    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Close as CloseIcon } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import useApiManager from '../../../../utils/Api/apiManager';
import UsersAutoComplete from '../../../Users/UsersAutoComplete';
import { AuthContext } from '../../../../context/AuthContext';
import dayjs from 'dayjs';

const AddTask = ({ open, onClose, fetchLeadTasks }) => {
    const { userId, userInfo } = useContext(AuthContext);
    const [isSimpleUser, setIsSimpleUser] = useState(true);
    const [ownerId, setOwnerId] = useState(userId || '');
    const [subject, setSubject] = useState('');
    const [dueDate, setDueDate] = useState(dayjs());
    const { leadId } = useParams();
    const [status, setStatus] = useState(0);
    const [priority, setPriority] = useState(0);
    const [description, setDescription] = useState('');

    useEffect(() => {
            if (userId) {
                setOwnerId(userId);
            }
            if (userInfo) {
                if (userInfo?.roles?.includes('Admin') || userInfo?.roles?.includes('Manager')) {
                    setIsSimpleUser(false);
                }
            }
        }, [userId, userInfo]);

    const { post } = useApiManager();


    const handleSave = async (event) => {
        event.preventDefault();
        const formData = {
            ownerId,
            subject,
            dueDate,
            leadId,
            status,
            priority,
            description
        };

        try {
            const responseData = await post('/tasks', formData);
            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        } finally {
            onClose();
            fetchLeadTasks();
        }
    }

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6">Create Task</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Divider sx={{ my: 2 }} />
                <form id='create-task' onSubmit={handleSave}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            required
                            label="Subject"
                            variant="outlined"
                            sx={{ mb: 2, flex: 1 }}  // Ensure equal weight
                            onChange={(e) => setSubject(e.target.value)}
                        />

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Due date"
                                sx={{ mb: 2, flex: 1 }}  // Ensure equal weight
                                value={dueDate}
                                onChange={(newDate) => setDueDate(newDate)}
                                slotProps={{
                                    textField: {
                                        required: true,
                                        variant: 'outlined',
                                        fullWidth: true,  // Ensure full width for the internal text field
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <FormControl fullWidth variant="outlined" >
                            <InputLabel>Status</InputLabel>
                            <Select
                                label="Status"
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                            >
                                <MenuItem value={0}>Not Started</MenuItem>
                                <MenuItem value={1}>Deferred</MenuItem>
                                <MenuItem value={2}>In Progress</MenuItem>
                                <MenuItem value={3}>Completed</MenuItem>
                                <MenuItem value={4}>Waiting for input</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth variant="outlined">
                            <InputLabel>Priority</InputLabel>
                            <Select
                                label="Priority"
                                value={priority}
                                onChange={(e) => setPriority(e.target.value)}
                            >
                                <MenuItem value={0}>High</MenuItem>
                                <MenuItem value={1}>Highest</MenuItem>
                                <MenuItem value={2}>Low</MenuItem>
                                <MenuItem value={3}>Lowest</MenuItem>
                                <MenuItem value={4}>Normal</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <FormControl fullWidth variant="standard" sx={{ mt: 2 }}>
                        <UsersAutoComplete setUserId={setOwnerId} userId={ownerId} disabled={isSimpleUser} />
                    </FormControl>

                    <TextField
                        fullWidth
                        label="Description"
                        variant="outlined"
                        sx={{ mt: 2, flex: 1 }}  // Ensure equal weight
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </form>
                <Box sx={{ mt: 2, textAlign: 'right' }}>
                    <Button onClick={onClose} sx={{ mr: 2 }}>Cancel</Button>
                    <Button type="submit" form="create-task" variant="contained" color="primary">Save</Button>

                </Box>

            </Box>

        </Modal >
    );
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 1,
    boxShadow: 24,
    p: 4,
};

export default AddTask;
